export function isPollVoteActivityMessage(mess) {
    return mess?.type === 'SYSTEM' && mess?.text === 'POLL_VOTE';
}
export function buildPollVoteDisplayEntries(messages, expandedGroupKeys) {
    const expanded = expandedGroupKeys instanceof Set
        ? expandedGroupKeys
        : new Set(Object.keys(expandedGroupKeys).filter((k) => expandedGroupKeys[k]));
    const entries = [];
    let i = 0;
    while (i < messages.length) {
        const current = messages[i];
        if (!isPollVoteActivityMessage(current)) {
            entries.push({
                kind: 'message',
                message: current,
                index: i,
                key: `msg-${current.id}`,
            });
            i += 1;
            continue;
        }
        let j = i;
        while (j < messages.length && isPollVoteActivityMessage(messages[j])) {
            j += 1;
        }
        const run = [];
        for (let k = i; k < j; k += 1) {
            run.push({ message: messages[k], index: k });
        }
        const groupKey = `pv-${run[0].message.id}-${run[run.length - 1].message.id}`;
        if (run.length > 3 && !expanded.has(groupKey)) {
            entries.push({
                kind: 'poll-vote-expand',
                groupKey,
                hiddenCount: run.length - 1,
                key: `exp-${groupKey}`,
            });
            const last = run[run.length - 1];
            entries.push({
                kind: 'message',
                message: last.message,
                index: last.index,
                key: `msg-${last.message.id}`,
            });
        }
        else {
            run.forEach((row) => {
                entries.push({
                    kind: 'message',
                    message: row.message,
                    index: row.index,
                    key: `msg-${row.message.id}`,
                });
            });
        }
        i = j;
    }
    return entries;
}
export function parsePollVoteSystemNote(systemNote) {
    if (!systemNote) {
        return { pollId: null, pollMessageId: null, question: '', answers: [] };
    }
    try {
        const note = JSON.parse(systemNote);
        return {
            pollId: note.poll_id != null ? Number(note.poll_id) : null,
            pollMessageId: note.poll_message_id != null ? Number(note.poll_message_id) : null,
            question: String(note.question || ''),
            answers: Array.isArray(note.answers) ? note.answers.map(String) : (note.answer ? [String(note.answer)] : []),
        };
    }
    catch {
        return { pollId: null, pollMessageId: null, question: '', answers: [] };
    }
}
export function truncatePollQuestion(text, max = 48) {
    const value = (text || '').trim();
    if (value.length <= max)
        return value;
    return `${value.slice(0, max).trim()}...`;
}
